<template>
    <div>
        <el-card class="box-card main_minheight" >
            <div slot="header" class="tishi"  >
                <span>上传头像</span>

            </div>
            <div style="text-align: center;">
                <el-upload

                        drag
                        :before-upload="beforeUploadFile"
                        :show-file-list="false"
                        :action=FILE_ACTION
                        :on-success="handleFileSuccess"
                        accept="image/*"
                        :multiple="false">

                    <img :src="faceimg" style="width: 100px;height: 100px;border-radius:5%">
                    <p>支持拖拽上传</p>
                </el-upload>
                <p style="font-size: 15px;color: #888888;">图片大小2M以内</p>

            </div>




        </el-card>



    </div>


</template>
<script>

import {dealResult} from '../../../api/common'

export default {
    name:'Upfaceimg',
    components: {

    },

    data() {
        return {

            lander :{},
            faceimg:'',
            FILE_ACTION:'',


        };
    },
    methods:{
        beforeUploadFile(file){
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
                return isLt2M;
            }

            this.loading = this.$loading({
                lock: true,
                text: "上传中，请稍等,,,,",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.5)",
            });
        },
        handleFileSuccess(res) {
            this.loading.close();
            dealResult(res);
            if( res.status==1){

                this.$message.success( '上传成功' );
                this.faceimg=res.obj;

                this.$store.dispatch('saveFaceimg',res.obj);
            }else{
                this.$message.error(res.msg);
            }

        },

    },mounted() {

            this.lander=JSON.parse(this.$store.state.logininfo);
            this.faceimg=this.lander.faceimg;
            this.FILE_ACTION=process.env.VUE_APP_API_ROOT+'/common/upimg?type=faceimg&uid='+this.lander.uid+"&token="+this.lander.token;

    }
};
</script>
<style scoped>

</style>
